<app-menu-common url="hr"></app-menu-common>

@if (hrService.backendMissing()) {
	<div class="hr-backend-warn">Backend RH non déployé : données indisponibles (voir docs/backend-brief-hr.md).</div>
}

<div class="flexrow hr-header">
	<mat-form-field>
		<mat-label>Recherche (nom, magasin, emploi du temps…)</mat-label>
		<input matInput (keyup)="applyFilter($event)">
	</mat-form-field>
	<mat-form-field class="store-filter">
		<mat-label>Établissement</mat-label>
		<mat-select [value]="storeFilter()" (selectionChange)="onStoreFilter($event.value)">
			<mat-option [value]="null">Tous</mat-option>
			@for (s of stores; track s.id) {
				<mat-option [value]="s.id">{{ s.name }}</mat-option>
			}
		</mat-select>
	</mat-form-field>
	<mat-checkbox [checked]="activeOnly()" (change)="onActiveToggle($event.checked)">Actifs uniquement</mat-checkbox>
	<span class="spacer"></span>
	<button mat-flat-button color="primary" id="newemployeebutton" (click)="onNew()">
		<mat-icon>person_add</mat-icon>&nbsp;Nouvel employé
	</button>
</div>

<div class="pagecontent">
	<table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef>Nom</th>
			<td mat-cell *matCellDef="let row">{{ row.name }}</td>
		</ng-container>
		<ng-container matColumnDef="store">
			<th mat-header-cell *matHeaderCellDef>Magasin par défaut</th>
			<td mat-cell *matCellDef="let row">{{ row.store }}</td>
		</ng-container>
		<ng-container matColumnDef="schedule">
			<th mat-header-cell *matHeaderCellDef>Emploi du temps par défaut</th>
			<td mat-cell *matCellDef="let row">{{ row.schedule }}</td>
		</ng-container>
		<ng-container matColumnDef="hours">
			<th mat-header-cell *matHeaderCellDef>Contrat / sem.</th>
			<td mat-cell *matCellDef="let row">{{ row.hours }}</td>
		</ng-container>
		<ng-container matColumnDef="mobility">
			<th mat-header-cell *matHeaderCellDef>Mobilité</th>
			<td mat-cell *matCellDef="let row">{{ row.mobility }}</td>
		</ng-container>
		<ng-container matColumnDef="active">
			<th mat-header-cell *matHeaderCellDef>Actif</th>
			<td mat-cell *matCellDef="let row">
				<mat-icon [class.inactive]="!row.active">{{ row.active ? 'check_circle' : 'cancel' }}</mat-icon>
				@if (isHrManager && row.anonymizable) {
					<!-- R8 (RGPD) — conservation écoulée : badge informatif, le geste reste au responsable RH. -->
					<span class="gdpr-chip" [matTooltip]="row.anonymizableTip">Anonymisable (RGPD)</span>
				}
			</td>
		</ng-container>

		<tr mat-header-row class="table_head" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row" (click)="onClickRow(row)"></tr>
	</table>

	@if (loaded && dataSource.data.length === 0) {
		<div class="hr-empty">Aucun employé. Créez la première fiche avec « Nouvel employé ».</div>
	} @else if (loaded && dataSource.filteredData.length === 0) {
		<div class="hr-empty">Aucun employé ne correspond aux filtres.</div>
	}
</div>
